import React, { useEffect } from 'react';
import '../../App.css';
import InquiryForm from '../InquiryForm';
import Footer from '../Footer';

function Inquire() {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 50);
          
    return () => clearTimeout(timer);
  }, []);
  return (
    <>
        <h1 className='inquire-hero'>Contact Me</h1>
        <h1 className='text'>Inquire about a photo shoot</h1>
        <InquiryForm />
        <div className="bottom-space"></div>
        <p className='bottom-space' />
        <Footer />
    </>
  )
}

export default Inquire
